export default __webpack_public_path__ + "static/media/news1.d1afe6a5.webp";